import { PortalServico } from '@/utils/';
import Sistema from './Sistema'
import Perfil from '../menu/Perfil'
/**
 * @type {SistemaServico}
 */
export default class SistemaServico extends PortalServico {

    listarSistemasArea() {
        const self = this
        return self.post('/uspproc/listar/portal/pubListarSistemasArea')
                 .then(dados => {
                     let mapeado = dados.map(item => self.criarDeJson(item))
                     return mapeado
                 })
    }

    listarPerfisPadrao() {
        return this.post('/uspproc/listar/portal/resListarPerfisPadrao')
                   .then(dados => dados.map(item => new Perfil(item.numnivseg, item.nomnivseg, item.nomsis)))
    }

    criarDeJson(json){
        return new Sistema(
            json.nomsis,
            json.nomarengcpoa,
            json.codarengcpoa,
            json.contexto
        )
    }

}